import React from "react";

import { StyledSpeachBalloon, StyledSpeachBalloonProps } from "./styled";

export type SpeachBalloonProps = StyledSpeachBalloonProps;

export const SpeachBalloon: React.FC<SpeachBalloonProps> = ({
  children,
  ...styles
}) => {
  return <StyledSpeachBalloon {...styles}>{children}</StyledSpeachBalloon>;
};
